import { render, staticRenderFns } from "./Priority.vue?vue&type=template&id=6624bb02&scoped=true"
import script from "./Priority.vue?vue&type=script&lang=ts"
export * from "./Priority.vue?vue&type=script&lang=ts"
import style0 from "./Priority.vue?vue&type=style&index=0&id=6624bb02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6624bb02",
  null
  
)

export default component.exports